"use strict";

module.exports = {
	withTr: require("./withTr").default,
	withTranslationSelector: require("./withTranslationSelector").default
	// withTrMethods: require("./withTrMethods").default
};